import image1 from '../../../assets/projectDetails/bottom1.jpg';
import image2 from '../../../assets/projectDetails/bottom2.jpg';
import image3 from '../../../assets/projectDetails/bottom3.jpg';
import image4 from '../../../assets/projectDetails/cos2.jpg';
import image5 from '../../../assets/projectDetails/bottom5.jpg';
import image6 from '../../../assets/projectDetails/bottom6.jpg';

export const fakeData = [
  {
    id: 1,
    img: image1,
    title: 'Oil and Gas',
    content:
      "Seismic surveys: The use of specialized equipment to create images of rock formations below the earth's surface to identify potential oil and gas reserves..",
  },
  {
    id: 2,
    img: image2,
    title: 'Waste Management',
    content:
      'Waste collection: The collection of waste materials from residential, commercial, and industrial sources for proper disposal or recycling.',
  },
  {
    id: 3,
    img: image3,
    title: 'Construction Management',
    content:
      'Project management: The planning, coordination, and execution of construction projects from start to finish.',
  },
  {
    id: 4,
    img: image4,
    title: 'Logistics Services',
    content:
      'Freight forwarding: The coordination of shipments of goods between suppliers, shippers, and customers. ',
  },
  {
    id: 5,
    img: image5,
    title: 'Waste Management Services',
    content:
      'Waste collection: The collection of waste materials from residential, commercial, and industrial sources for proper disposal or recycling.',
  },
  {
    id: 6,
    img: image6,
    title: 'Ware Housing',
    content:
      'Supply chain management: The coordination and management of the movement of goods and materials from suppliers to customers.',
  },
];